import last from 'lodash/last';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import identity from 'lodash/identity';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import store from '@Store';
import { QUERY_FILE } from './constants';

const { parser } = QUERY_FILE;
const SUPPORTED_FORMATS = parser.support.split(',');
/**
 * Validate file on client side
 * @param file
 * @returns {boolean|object}
 */
export const isValidFile = (file) => {
  if (!file) return 'File is undefined.';
  if (file.name) {
    const ext = last(file.name.toLowerCase().split('.'));
    if (SUPPORTED_FORMATS.indexOf(`.${ext}`) === -1) {
      return { message: `Unsupported format. Supported formats: ${parser.support}.`, errorNumber: 19 };
    }
  }
  return true;
};

/**
 * Parse query file
 * @param file
 * @returns {*} Promise
 */
export const parseFile = (file) => {
  const validationResult = isValidFile(file);

  if (validationResult !== true) {
    return Promise.reject(new Error(validationResult));
  }

  const requestData = new FormData();
  requestData.append('file', file);
  return MessageBroker.send(RequestUrls.searchQueryFile, requestData, {
    ignoreErrorModal: true,
    transformRequest: identity,
    headers: { 'Content-Type': undefined },
  });
};

/**
 * Show Query file
 * @param queryFile
 * @returns
 */
export const showQueryFile = (queryFile) => {
  history.push(paths.ADVANCED);
  history.push({
    pathname: paths.ADVANCED,
    state: { importedQuery: queryFile },
  });
  store.dispatch({ type: 'GET_IMPORTED_QUERY', payload: { importedQuery: queryFile } });
};
